"use strict";

function initPosIdentifierSearch() {
  const input = document.getElementById("pos-identifier-input");
  if (!input) return;

  const optionsList = document.getElementById("pos-identifier-options");
  const hiddenField = document.getElementById("pos-identifier-id");
  const items = optionsList.querySelectorAll("[data-pos-identifier-id]");

  function showOptions() {
    optionsList.style.display = "";
    filterOptions();
  }

  function hideOptions() {
    setTimeout(function () {
      optionsList.style.display = "none";
    }, 200);
  }

  function filterOptions() {
    const query = input.value.trim().toLowerCase();
    items.forEach(function (item) {
      var label = item.dataset.label.toLowerCase();
      item.style.display = label.includes(query) ? "" : "none";
    });
  }

  input.addEventListener("focus", showOptions);
  input.addEventListener("blur", hideOptions);
  input.addEventListener("input", function () {
    hiddenField.value = "";
    filterOptions();
  });

  optionsList.addEventListener("click", function (e) {
    const item = e.target.closest("[data-pos-identifier-id]");
    if (!item) return;

    hiddenField.value = item.dataset.posIdentifierId;
    input.value = item.dataset.label;
    optionsList.style.display = "none";
  });
}

document.addEventListener("turbo:load", initPosIdentifierSearch, true);
document.addEventListener("DOMContentLoaded", initPosIdentifierSearch, true);
